/**
 * FAQView Component
 */

import './faq-view.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import Heading from '../../atoms/text/Heading';
import { Paragraph } from '../../atoms/text/Label';
import { IFAQCategory } from './';

interface IOwnProps {
  className?: string;
  data: IFAQCategory;
}

type FAQViewProps = IOwnProps;

const classes = new BEM('faq-view');

export default class FAQView extends React.Component<FAQViewProps> {

  render() {
    const extraClasses = classNames(this.props.className);

    return (
      <div {...classes('', '', extraClasses)}>
        <VelocityTransitionGroup
          component="ol"
          enter={{
            animation: 'transition.slideUpIn',
            delay: 150,
            duration: 250,
            stagger: 150,
          }}
          leave={{
            animation: 'transition.fadeOut',
            duration: 150,
            stagger: 50,
          }}
          {...classes('list')}
        >
          {this.props.data.questions.map(({ id, question, answer }, index) => (
            <li key={`faq-${this.props.data.id}-${index}`} {...classes('list__item')}>
              <a id={id} />
              <Heading is="h3" {...classes('list__item__title')}>{question}</Heading>
              {typeof answer === 'string' ?
                <Paragraph {...classes('list__item__text')}>{answer}</Paragraph>
                : <div {...classes('list__item__text')}>{answer}</div>}
            </li>
          ))}
        </VelocityTransitionGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/FAQ/FAQView.tsx